import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach((table) => this.#formatTable(table));
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    this.#labelTableCells(table);

    if (table.parentElement?.classList.contains('rte-table-wrapper')) return;

    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }

  /**
   * Adds header labels to data cells so wide RTE tables can collapse on mobile.
   * @param {HTMLTableElement} table
   */
  #labelTableCells(table) {
    const headers = Array.from(table.tHead?.rows[0]?.cells || [])
      .map((cell) => cell.textContent.trim())
      .filter(Boolean);

    if (!headers.length) return;

    Array.from(table.tBodies).forEach((tbody) => {
      Array.from(tbody.rows).forEach((row) => {
        Array.from(row.cells).forEach((cell, index) => {
          if (cell.tagName !== 'TD' || cell.hasAttribute('data-label')) return;

          const label = headers[index];
          if (label) cell.dataset.label = label;
        });
      });
    });
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
